module.exports = __webpack_public_path__ + "src/assets/img/page4/f7933200aa3c641213cc66e727f67a9f.png";